import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import { array, func, number } from 'prop-types';

const propTypes = {
  currencies: array.isRequired,
  onCurrencyChange: func.isRequired,
  active: number.isRequired,
};
const defaultProps = {
  currencies: [],
  active: 0,
};

const PaymentsCurrencyControl = ({ currencies, onCurrencyChange, active }) => (
  <div className="payments-currency-controls">
    <ButtonGroup className='currencies'>
      {currencies.length > 0 &&
        currencies.map((currency, index) => (
          <Button
            type="button"
            size="sm"
            color="primary"
            active={index === active}
            onClick={onCurrencyChange.bind(null, index)}
            key={currency}
            outline
          >
            {currency}
          </Button>
        ))}
    </ButtonGroup>
  </div>
);

PaymentsCurrencyControl.propTypes = propTypes;
PaymentsCurrencyControl.defaultProps = defaultProps;

export default PaymentsCurrencyControl;
